<div class="language-selector" *ngIf="languages.length > 1">
  <button
    #trigger
    type="button"
    class="language-selector__trigger"
    data-testid="language-selector-trigger"
    aria-haspopup="true"
    [attr.aria-expanded]="open"
    [attr.aria-label]="'common.selectLanguage' | translate"
    (click)="toggle()"
  >
    <span class="language-selector__trigger__icon material-icons" aria-hidden="true">public</span>
    <span class="language-selector__trigger__label">{{ selectedlanguageData?.name }}</span>
  </button>

  <div class="language-selector__panel" [class.is-open]="open" role="menu">
    <button
      *ngFor="let language of languages"
      type="button"
      role="menuitem"
      class="language-selector__panel__option"
      [class.is-selected]="language.code === selectedlanguage"
      [attr.aria-current]="language.code === selectedlanguage"
      [attr.data-testid]="'language-option-' + language.code"
      (click)="onlanguageChange(language.code)"
    >
      <span class="language-selector__panel__option__name">{{ language.name }}</span>
      <span
        class="language-selector__panel__option__check material-icons"
        aria-hidden="true"
        *ngIf="language.code === selectedlanguage"
        >check</span
      >
    </button>
  </div>
</div>
